export const ACTION_TYPES = {
  GET_DASHBOARDS_BY_WORKSPACE_REQUEST: 'GET_DASHBOARDS_BY_WORKSPACE_REQUEST',
  GET_DASHBOARDS_BY_WORKSPACE_SUCCESS: 'GET_DASHBOARDS_BY_WORKSPACE_SUCCESS',
  GET_DASHBOARDS_BY_WORKSPACE_FAILURE: 'GET_DASHBOARDS_BY_WORKSPACE_FAILURE',
  CREATE_DASHBOARD_REQUEST: 'CREATE_DASHBOARD_REQUEST',
  CREATE_DASHBOARD_SUCCESS: 'CREATE_DASHBOARD_SUCCESS',
  CREATE_DASHBOARD_FAILURE: 'CREATE_DASHBOARD_FAILURE',
  GET_DASHBOARD_REQUEST: 'GET_DASHBOARD_REQUEST',
  GET_DASHBOARD_SUCCESS: 'GET_DASHBOARD_SUCCESS',
  GET_DASHBOARD_FAILURE: 'GET_DASHBOARD_FAILURE',
  UPDATE_DASHBOARD_REQUEST: 'UPDATE_DASHBOARD_REQUEST',
  UPDATE_DASHBOARD_SUCCESS: 'UPDATE_DASHBOARD_SUCCESS',
  UPDATE_DASHBOARD_FAILURE: 'UPDATE_DASHBOARD_FAILURE',
  DELETE_DASHBOARD_REQUEST: 'DELETE_DASHBOARD_REQUEST',
  DELETE_DASHBOARD_SUCCESS: 'DELETE_DASHBOARD_SUCCESS',
  DELETE_DASHBOARD_FAILURE: 'DELETE_DASHBOARD_FAILURE',
};
